import React from "react"
import { withTheme } from "emotion-theming"

const Arrow = ({ theme, colour, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={style}>
    <path
      fill={colour ? colour : theme.color}
      d="M22.41 10.2L12.706.4A.99.99 0 0 0 12 .1a.992.992 0 0 0-.7.289L1.573 10.02a2.6 2.6 0 0 0 .1 3.657 2.59 2.59 0 0 0 3.657.1l3.743-3.732a.25.25 0 0 1 .426.178v11.666C9.483 23.448 11.164 23.9 12 23.9a2.276 2.276 0 0 0 2.5-2.034V10.241a.25.25 0 0 1 .431-.173l3.722 3.881A2.658 2.658 0 0 0 22.41 10.2z"
    />
  </svg>
)

export default withTheme(Arrow)
